export default class GetAllDirigidos {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute() {
    try {
      const result = await this.#repository.getAllDirigidos()
      return result
    } catch (error) {
      console.error('Error al obtener el catálogo de dirigidos:', error)
      throw error
    }
  }
}
